import React from "react"
import styled from "styled-components"
import NavbarProfilePopup from "./navbar-profile-popup"
import PropTypes from "prop-types"

const NavbarButton = styled.div`
  display: flex;
  height: 40px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  border: 1px solid #315254;
  color: #315254;
  background: ${props => (props.$show ? "#315254" : "#fff")};
  color: ${props => (props.$show ? "#fff" : "#315254")};

  min-width: max-content;
  cursor: pointer;
  transition: all 0.5;

  &:hover {
    border-radius: 24px;
    border: 1px solid #315254;
    background: #315254;
    color: white;
  }
`

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const PopupHolder = styled.div`
  max-width: 0;
  max-height: 0;
  position: relative;
  display: ${props => (props.$show ? "block" : "none")};
`
const NavbarProfile = ({ user, signout, setShowpopup, showPopup }) => {
  return (
    <ItemWrapper>
      <NavbarButton
        $show={showPopup === 4}
        onMouseEnter={() => setShowpopup(4)}
      >
        Profile
      </NavbarButton>
      <PopupHolder $show={showPopup === 4}>
        <NavbarProfilePopup
          user={user}
          signout={signout}
          showPopup={showPopup}
          setShowpopup={setShowpopup}
        />
      </PopupHolder>
    </ItemWrapper>
  )
}

NavbarProfile.propTypes = {
  user: PropTypes.object,
  signout: PropTypes.func,
  setShowpopup: PropTypes.func,
  showPopup: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
}

export default NavbarProfile
